import { RegistereRibbonButton, useRibbon, useSelectionContext } from "@eavfw/apps";
import { useEffect } from "react";

RegistereRibbonButton("CUSTOM_IMPERSONATE", ({ key }) => {
    const { addButton, removeButton, buttons } = useRibbon();
    const { selection } = useSelectionContext();

    useEffect(() => {
        console.log("Adding CUSTOM_IMPERSONATE", buttons);


        addButton({
            key: "CUSTOM_IMPERSONATE",
            text: "Impersonate",
            iconProps: { iconName: 'FollowUser' },
            title: "Impersonate",
            disabled: typeof selection === "undefined",
            onClick: (e) => {
                console.log(selection.getItems());
                console.log(selection.getSelection());
                let selected = selection.getSelection();
                if (selected.length === 1) {
                    fetch(`${process.env.NEXT_PUBLIC_BASE_URL}.auth/signin/impersonate`, {
                        body: JSON.stringify(selected[0]),
                        credentials: "include",
                        method: "POST"
                    }).then(() => {
                        window.location.reload();
                    });
                }

            }
        });


        return () => {
            console.log("Removing CUSTOM_IMPERSONATE")
            removeButton("CUSTOM_IMPERSONATE");
        }
    }, [selection]);
});